export default [
  {
    root: { icon: 'fas fa-home', title: 'Home', link: '/home' },
  },
  {
    root: { icon: 'fas fa-file-invoice-dollar', title: 'Contracheque Online' },
    leaves: [
      {
        title: 'Visualizar',
        link: '/contracheque',
      },
    ],
  },
  {
    root: { icon: 'fas fa-sticky-note', title: 'Informe de Rendimentos' },
    leaves: [
      {
        title: 'Visualizar',
        link: '/informederendimentos',
      },
    ],
  },
];
